<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <label>Unidade solicitante</label>
                  <v-select
                    v-model="pedido.unidade_solicitante"
                    class="vselect"
                    :options="unidades"
                    :reduce="(unidades) => unidades.id"
                    :label="'nome'"
                  />
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitada</label>
                  <v-select
                    v-model="pedido.unidade_solicitada"
                    class="vselect"
                    :options="unidades"
                    :reduce="(unidades) => unidades.id"
                    :label="'nome'"
                    :disabled="pedido_material.length ? true : false"
                  />
                </div>
                <div class="col-md-12">
                  <label>Observações</label>
                  <ckeditor
                    :editor="editor"
                    v-model="pedido.observacoes"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
                <div class="col-md-9">
                  <label>Material</label>
                  <v-select
                    v-model="adicao.obj_material"
                    class="vselect"
                    :options="materiais"
                    :label="'nome'"
                  />
                </div>
                <div class="col-md-2">
                  <label>Quantidade</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="adicao.quantidade"
                  />
                </div>
                <div class="col-md-1">
                  <label>Adicionar</label>
                  <button class="btn btn-primary" @click="add">
                    <i class="fa fa-plus" />
                  </button>
                </div>
                <div
                  class="col-md-12 row p-0 m-0"
                  id="lotes"
                  v-for="(material_pedido, id) in pedido_material"
                  :key="id"
                >
                  <div class="col-md-9 mt-1">
                    {{ material_pedido.material }}
                  </div>
                  <div class="col-md-2 mt-1 pl-2">
                    {{ material_pedido.quantidade }}
                  </div>
                  <div class="col-md-1 mt-1">
                    <button class="btn btn-danger" @click="remove(id)">
                      <i class="fa fa-trash" />
                    </button>
                  </div>
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/pedidos" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "imageUpload",
  data() {
    return {
      pedido_material: [],
      adicao: {
        id: "",
        material: "",
        obj_material: {},
        quantidade: "",
      },
      materiais: [],
      pedido: {
        unidade_solicitante: "",
        unidade_solicitada: "",
        observacoes: "",
        rapido: true,
      },
      unidades: [],
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        language: "pt-br",
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "numberedlist",
          "bulletedlist",
          "|",
          "outdent",
          "indent",
          "|",
          "blockquote",
          "inserttable",
          "undo",
          "redo",
        ],
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "pedidos";

      if (!self.add()) {
        return;
      }

      axios
        .post(api, { pedido: self.pedido, materiais: self.pedido_material })
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPedidos: function (id) {
      const self = this;
      const api = self.$store.state.api + "pedidos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.pedido = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMateriais: function () {
      const self = this;
      const api = self.$store.state.api + `materiais?paginated=false`;

      axios
        .get(api)
        .then((response) => {
          self.materiais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    add: function () {
      const self = this;

      if (self.adicao.obj_material && self.adicao.quantidade) {
        self.pedido_material.push({
          id: self.adicao.obj_material.id,
          material: self.adicao.obj_material.nome,
          quantidade: self.adicao.quantidade,
        });

        self.adicao = {
          obj_material: {},
          id: "",
          material: "",
          quantidade: "",
        };

        return true;
      }

      if (self.adicao.obj_material.id) {
        if (!self.adicao.obj_material || !self.adicao.quantidade) {
          self.$message(
            null,
            "Por favor preencha todos os campos do material",
            "error"
          );

          return false;
        }
      }

      return true;
    },
    remove: function (id) {
      const self = this;

      self.pedido_material.splice(id, 1);
    },
  },
  mounted: function () {
    const self = this;
    $("#pedidos").focus();

    self.getUnidades();
    self.getMateriais();
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>